import { PopcornBreakAnimation } from '../../animations/PopcornBreakAnimation';
import { BlockId } from '../../defs/block';
import {
  BlockEntity,
  PopcornBlockEntity,
  spawnBlockEntity,
} from '../../entities/BlockEntity';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';

export type CornEffectOptions = {
  subject: BlockEntity;
  spawnPopcorn: boolean;
};

const spawnId: BlockId = 'popcorn';

export class CornEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: CornEffectOptions;

  constructor(scene: GameScene, options: CornEffectOptions) {
    this.scene = scene;
    this.options = options;
  }

  public static assets() {
    return blockViewAssets(spawnId);
  }

  public async execute() {
    // Play the break animation if not spawning popcorn block
    if (!this.options.spawnPopcorn) {
      this.playBreakAnimation(this.options.subject);
      return;
    }

    // Spawn a popcorn block entity in place
    const entity = spawnBlockEntity(
      this.scene,
      { id: spawnId },
      this.options.subject.c.position.mapPosition,
    ) as PopcornBlockEntity;

    // Play transition animation
    entity.c.blockPopcorn.view.playTransition();
  }

  private async playBreakAnimation(entity: BlockEntity) {
    const animation = new PopcornBreakAnimation();
    // Spawn an overlay entity for the animation
    const overlay = spawnOverlayEntity(
      this.scene,
      entity.c.position.mapPosition,
      entity.c.block.props,
      () => animation,
      'foreground',
    );
    // Play the animation
    await animation.start();
    // Despawn the overlay entity
    despawnOverlayEntity(this.scene, overlay);
  }
}
